module.exports = __webpack_public_path__ + "img/05010010.e8f8e977.jpg";